<app-dialog [title]="'action.build' | translate">
  <ng-container appDialogContent>
    <app-toolbar #toolbar></app-toolbar>
  </ng-container>
  <ng-container appDialogActions>
    <app-button-cancel></app-button-cancel>
    <app-button-primary [text]="'action.build' | translate" (action)="toolbar.onBuild($event)"></app-button-primary>
  </ng-container>
</app-dialog>
